module.exports = __webpack_public_path__ + "assets/images/test/sample-transport-desktop.png?v=f1c77077";